import { AppBar, Box, IconButton, Toolbar, Tooltip, Typography } from '@mui/material';
import fileDownload from 'js-file-download';
import { action, computed, makeObservable, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import RecarregarDoCache from '@mui/icons-material/Refresh';
import '../../css/cabecalho.css';
import ReactComponent from '../ReactComponent';
import BuscarProcessoPorNumero from './BuscarProcessoPorNumero';
import NotificacoesVotoAlterado from './NotificacoesVotoAlterado';
import ProgressoProcessamentoLote from './ProgressoProcessamentoLote';
import ControleDeSessao from './ControleDeSessaoPauta';
import IncluirProcessoSessao from './IncluirProcessoSessao';
import ModalPresidenteSessao from './ModalPresidenteSessao';
import RecarregarCacheServidor, { MODULO } from './RecarregarCacheServidor';
import FiltrarPorNumerosProcessos from './FiltrarPorNumerosProcessos';
import ModalProcuradorSessao from './ModalProcuradorSessao';
import ExportarRelatoriosListaProcessos from './toolbar/ExportarRelatoriosListaProcessos';
import ModalControlePermissaoSustentacao from './ModalControlePermissaoSustentacao';
import AlertasQuorum from './AlertasQuorum';

class ToolbarPreSessao extends ReactComponent {
    cursor = 'pointer';

    recarregarListaProcessos = () => {
        this.mudarCursorWait();
        this.salaSessaoStore.recarregarListaProcessos();
        setTimeout(() => {
            this.mudarCursorPointer();
        }, 5000);
    };

    constructor(props) {
        super(props);

        makeObservable(this, {
            cursor: observable,
            recarregarListaProcessos: action,
            mudarCursorWait: action,
            mudarCursorPointer: action,
            pointerEvents: computed,
            sessoes: computed
        });
    }

    mudarCursorWait() {
        this.cursor = 'wait';
    }

    mudarCursorPointer() {
        this.cursor = 'pointer';
    }

    downloadAta() {
        let promisse = this.sessaoService.gerarAta(this.sessaoStore.idSessaoSelecionada);
        promisse.then((response) => {
            fileDownload(response, 'ata_' + this.sessaoStore.idSessaoSelecionada + '.html', 'text/html');
        });
    }

    ordenarSustentacoes = async () => {
        if (!this.sessaoStore.sessaoSelecionada) {
            this.mensagemStore.abrirMensagemInfo(
                'Não há sessão selecionada ou não existem processos na sessão selecionada.'
            );
        } else if (
            window.confirm(
                'Deseja ordenar as inscrições conforme RI do TST, sobrescrevendo sequenciais já atribuídos e sem deixar lacunas?'
            )
        ) {
            let alteracoes = await this.sustentacoesService.ordenar(this.sessaoStore.sessaoSelecionada.processos);
            if (alteracoes > 0) {
                await this.salaSessaoStore.recarregarListaProcessos(true);
            }
            await this.sessaoService.fecharLivroPreferencias(this.sessaoStore.idSessaoSelecionada);
            this.mensagemStore.abrirMensagemSucesso('Inscrições de advogados ordenadas');
        }
    };

    get pointerEvents() {
        return this.cursor === 'wait' ? 'none' : 'auto';
    }

    get sessoes() {
        return (this.sessaoStore.sessaoSelecionada && this.sessaoStore.sessaoSelecionada.sessoes) || [];
    }

    render() {
        return (
            <AppBar
                position="static"
                className="selectionAmarelo"
                style={{ display: this.sessaoStore.idSessaoSelecionada !== -1 ? '' : 'none', zIndex: '1' }}
            >
                <Toolbar
                    variant="dense"
                    sx={{
                        display: 'flex',
                        backgroundColor: '#1976d2',
                        minHeight: '40px',
                        color: 'black',
                        paddingLeft: '14px',
                        justifyContent: 'space-between'
                    }}
                    style={{ padding: '0px 8px', zIndex: '1' }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ marginRight: '10px' }}>
                            <BuscarProcessoPorNumero
                                processos={this.preSessaoStore.processosSessao}
                                callbackAbrirProcesso={this.preSessaoStore.abrirProcesso}
                            />
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                alignContent: 'center',
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                                color: 'white',
                                marginLeft: '2px'
                            }}
                        >
                            <FiltrarPorNumerosProcessos storeListagemProcessos={this.preSessaoStore} />
                        </div>
                        <div
                            style={{
                                boxShadow: '2px 0px 0px 0px rgba(0,0,0,0.2)',
                                width: '2px',
                                margin: '4px',
                                height: '24px',
                                color: 'white'
                            }}
                        />
                    </Box>
                    <div
                        style={{
                            display: 'flex',
                            alignContent: 'center',
                            alignItems: 'center',
                            justifyContent: 'flex-end',
                            height: '40px',
                            color: 'white',
                            marginRight: '6px',
                            width: '38%'
                        }}
                    >
                        <AlertasQuorum />
                        {this.renderFerramentas()}
                    </div>
                </Toolbar>
            </AppBar>
        );
    }

    renderFerramentas() {
        return (
            <div style={{ display: 'flex', color: 'white', alignContent: 'center', alignItems: 'center' }}>
                <div
                    style={{
                        boxShadow: '2px 0px 0px 0px rgba(0,0,0,0.2)',
                        width: '2px',
                        margin: '4px',
                        height: '24px',
                        color: 'white'
                    }}
                />
                <span style={{ pointerEvents: this.pointerEvents, display: 'flex', alignItems: 'center' }}>
                    <NotificacoesVotoAlterado />
                    <ProgressoProcessamentoLote />
                </span>
                <Tooltip title={<Typography>Recarregar dados da sessão</Typography>}>
                    <span>
                        <IconButton
                            className="corBotaoAmarelo"
                            onClick={this.recarregarListaProcessos}
                            disabled={this.cursor === 'wait' ? true : false}
                        >
                            <RecarregarDoCache sx={{ color: 'white', cursor: this.cursor }} />
                        </IconButton>
                    </span>
                </Tooltip>
                <RecarregarCacheServidor modulo={MODULO.SALA_SESSAO} />
                <ControleDeSessao recarregarListaProcessos={this.recarregarListaProcessos} />
                <Box sx={{ pointerEvents: this.pointerEvents, ml: 1 }}>
                    <ModalControlePermissaoSustentacao />
                </Box>
                <IncluirProcessoSessao />
                <div style={{ pointerEvents: this.pointerEvents }}>
                    <ModalPresidenteSessao corIcone="white" />
                </div>
                <div style={{ pointerEvents: this.pointerEvents }}>
                    <ModalProcuradorSessao
                        corIcone="white"
                        sessoes={this.sessoes}
                    />
                </div>
                <div style={{ pointerEvents: this.pointerEvents }}>
                    <ExportarRelatoriosListaProcessos />
                </div>
            </div>
        );
    }
}

export default inject('stores')(observer(ToolbarPreSessao));
